import Notification from 'components/Notification';
import {FC} from 'react';
import {t} from 'ttag';
import {UiLongTask} from 'types/long-task';

const MORE_ERRORS_THRESHOLD = 4;

type LongTaskErrorsProps = {
    UiLongTask: UiLongTask | undefined;
};

const LongTaskErrors: FC<LongTaskErrorsProps> = ({UiLongTask}) => {
    if (!UiLongTask) return null;

    const errors = UiLongTask.errors.slice(0, MORE_ERRORS_THRESHOLD);
    const totalErrors = UiLongTask.errors.length;
    const hasMoreErrors = UiLongTask.errors.length > MORE_ERRORS_THRESHOLD;

    return (
        <div className="flex flex-col gap-2">
            {errors.map((error, index) => (
                <Notification key={`${error}${index}`} type="danger">
                    {error}
                </Notification>
            ))}
            {hasMoreErrors && (
                <Notification type="danger">{t`More errors found (${totalErrors} total)`}</Notification>
            )}
        </div>
    );
};

export default LongTaskErrors;
